module.exports = __webpack_public_path__ + "img/nature-78.82752328.jpg";